<div class="c-footer">
	<div class="u-container flex-row flex-gap--xxl">
		<img [alt]="logoAlt" [src]="logo" />

		<div class="flex--1">
			<p class="u-text--bold">
				<ng-container *ngIf="boldText" [ngTemplateOutlet]="boldText"></ng-container>
			</p>

			<ng-content></ng-content>

			@if (showCookieSettings()) {
				<button (click)="openCookieSettings()">Cookie settings</button>
			}
		</div>
	</div>
</div>
